// Native-app stickers arrive as text "lottie:<id>"; map ids to emoji (native app's list).
const IDS = {
  "love-heart": "❤️", "love-eyes": "😍", "love-kiss": "😘", "love-smiling": "🥰", "love-sparkling": "💖", "love-two": "💕", "love-revolving": "💞", "love-growing": "💗",
  "happy-grin": "😀", "happy-joy": "😂", "happy-smile": "😄", "happy-blush": "😊", "happy-cool": "😎", "happy-rofl": "🤣", "happy-slight": "🙂", "happy-star": "🤩",
  "celebrate-party": "🎉", "celebrate-confetti": "🎊", "celebrate-face": "🥳", "celebrate-sparkles": "✨", "celebrate-fireworks": "🎆", "celebrate-gift": "🎁", "celebrate-trophy": "🏆", "celebrate-100": "💯",
  "sad-cry": "😢", "sad-sob": "😭", "sad-disappointed": "😞", "sad-pensive": "😔", "sad-relieved": "😥", "sad-pleading": "🥺", "sad-fearful": "😨", "sad-scream": "😱",
  "hands-thumbsup": "👍", "hands-clap": "👏", "hands-raised": "🙌", "hands-wave": "👋", "hands-fist": "👊", "hands-victory": "✌️", "hands-shake": "🤝", "hands-pray": "🙏",
};

export const isLottieSticker = (text) => typeof text === "string" && text.startsWith("lottie:");

// Emoji for a "lottie:<id>" text, or null if unknown / not a lottie sticker.
export const lottieEmoji = (text) => (isLottieSticker(text) ? IDS[text.slice(7)] || null : null);

// Text to show in previews: mapped emoji, "Sticker" for unknown ids, otherwise the text unchanged.
export const stickerPreview = (text) => (isLottieSticker(text) ? lottieEmoji(text) || "Sticker" : text);

export const notoLottieUrl = (emoji) => {
  const cps = Array.from(emoji).map((c) => c.codePointAt(0)).filter((cp) => cp !== 0xfe0f);
  return `https://fonts.gstatic.com/s/e/notoemoji/latest/${cps.map((cp) => cp.toString(16)).join("_")}/lottie.json`;
};
